import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useModalStore, ModalType } from '../store/modalStore';
import { useRoute } from '@react-navigation/native';
import { ROUTES } from '../shared/constants/routes';
import { RadialGradientBox } from './RadialGradientBox';
import ThinkOLogo from './ThinkoLogo';
import { TrackedPressable } from '../analytics/components';

function StickyAiAssistant() {
    const setModalShown = useModalStore((state) => state.setModalShown);
    const route = useRoute();
    const onPress = () => {
        setModalShown(ModalType.AI_ASSISTANT, { articleId: (route?.params as any)?.articleId, showGeneralAssistant: route?.name === ROUTES.HOME });
    };
    return (
        <View pointerEvents="box-none" style={styles.wrapper} id={ModalType.AI_ASSISTANT}>
            <RadialGradientBox>
                <TrackedPressable context={{ cta: ModalType.AI_ASSISTANT }} onPress={onPress}>
                    <ThinkOLogo size={65} thick/>
                </TrackedPressable>
            </RadialGradientBox>
        </View>
    );
}

const styles = StyleSheet.create({
    wrapper: {
        position: 'absolute',
        right: 16,
        bottom: 64,
        zIndex: 999,
    },
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 5,
        borderRadius: 999,
        elevation: 6, // Android shadow
        shadowColor: '#000', // iOS shadow
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 6,
    }
});

export default React.memo(StickyAiAssistant);